import type { Key } from './en.js';

export const ru: Record<Key, string> = {
  'app.title': 'Tellvo.app — настройка телефона',
  'brand.name': 'Tellvo.app',
  'theme.label': 'Тема страницы',
  'theme.system': 'Как в системе',
  'theme.light': 'Светлая',
  'theme.dark': 'Тёмная',

  'connect.connecting': 'Подключаемся к сервису настройки…',
  'connect.waitingPhone': 'Ждём данные с iPhone…',

  'pair.title': 'Подключите iPhone',
  'pair.lead': 'Настраивайте линии на большом экране. Всё, что вы вводите, сразу появляется на iPhone.',
  'pair.qr': 'Наведите камеру iPhone',
  'pair.qrLabel': 'QR-код для камеры iPhone',
  'pair.codeLabel': 'Код сопряжения',
  'pair.privacy': 'Всё, что вы введёте, шифруется между этим браузером и телефоном. Сервер Tellvo.app видит только шифр.',
  'pair.timer': 'Код действует ещё {time}',
  'pair.or': 'или введите код в Tellvo.app',
  'pair.expired.title': 'Код больше не действует',
  'pair.expired.text': 'Он действовал 2 минуты. Получите новый и наведите камеру ещё раз.',
  'pair.renew': 'Новый код',
  'pair.lost.title': 'Связь прервалась',
  'pair.lost.text': 'Переподключаемся. QR останется прежним, код обновится.',
  'pair.offline.title': 'Связь не вернулась',
  'pair.offline.text': 'Проверьте интернет на компьютере и получите новый код.',
  'sync.reconnecting': 'Переподключение…',
  'sync.offline': 'Нет связи',
  'notice.reconnecting': 'Связь со службой настройки прервалась, переподключаемся. Можно продолжать: изменения подождут.',
  'notice.offline': 'Связь не вернулась. Изменения сохранены на этой странице и уйдут, когда она появится.',
  'action.retry': 'Повторить',

  'confirm.title': 'Подключился iPhone. Разрешить?',
  'confirm.text': 'Разрешайте, только если вы сами ввели код на этом телефоне.',
  'confirm.allow': 'Разрешить',
  'confirm.reject': 'Отклонить',

  'sync.online': 'На связи',
  'sync.away': 'В фоне',
  'sync.device': '{device} · Tellvo.app {version}',
  'sync.pending': 'Не синхронизировано: {count}',

  'accounts.title': 'Линии',
  'accounts.add': 'Добавить линию',
  'accounts.empty': 'Учёток пока нет. Нужны сервер, логин и пароль от провайдера.',
  'accounts.addFirst': 'Добавить линию',
  'accounts.toggle': 'Линия «{name}» активна',

  'state.working': 'Работает',
  'state.connecting': 'Подключение',
  'state.error': 'Ошибка',
  'state.off': 'Выключена',
  'state.idle': 'Неактивна',
  'state.waiting': 'Ждёт',

  'line.notOnPhone': 'Ещё не на iPhone',
  'line.pendingAway': 'Применится, когда iPhone вернётся',
  'line.pendingOnline': 'Отправляется на iPhone',
  'line.deleting': 'Удалится после подтверждения на iPhone',
  'line.failed': 'Не применено',
  'line.off': 'Регистрация выключена',
  'line.error': 'Не регистрируется',
  'line.pushMissing': 'Не звонит при закрытом',

  'editor.new': 'Новая учётка',
  'editor.back': 'К списку учёток',
  'editor.pick': 'Выберите учётку слева или добавьте новую.',
  'editor.advanced': 'Дополнительно',
  'editor.passwordKeep': 'Сохранён на iPhone. Оставьте пустым, чтобы не менять.',
  'editor.failed': 'iPhone не применил эту учётку: {reason}',
  'editor.registrationFailed': '{reason} Проверьте сервер, логин и пароль или попробуйте другой транспорт.',
  'editor.switchFirst': 'Сначала сохраните или отмените изменения.',

  'push.off': 'Звонки при закрытом приложении выключены.',
  'push.transport': 'При закрытом приложении звонок не дойдёт: сервис push пока работает по UDP и TCP, а у этой учётки {transport}.',
  'push.afterSave': 'Отправится на сервис push после сохранения.',
  'push.noPassword': 'При закрытом приложении звонок не дойдёт: на iPhone нет пароля этой учётки.',
  'push.noToken': 'iPhone ещё не выдал токен для push. Откройте Tellvo.app на телефоне.',
  'push.refused': 'Сервис push не принял учётку ({status}). При закрытом приложении звонок не дойдёт.',
  'push.unreachable': 'Сервис push не ответил. Tellvo.app повторит при следующем изменении.',
  'push.useUdp': 'Выбрать UDP',
  'accounts.active': 'Активна',
  'accounts.pushToggle': 'Звонки при закрытом приложении: {name}',
  'line.pushNoRoom': 'Нет места для push: {used} из {limit}',
  'line.pushNoRoomBare': 'Нет места для push',
  'fact.dnd': 'Не беспокоить на iPhone',
  'push.noRoom': 'Нет места в тарифе: push включён у {used} из {limit}.',
  'push.noRoomBare': 'Нет места в тарифе: push уже включён у всех линий, которые он позволяет.',
  'push.otherDevices': 'Все места тарифа заняты другими устройствами.',
  'push.offAll': 'Выключены для всех линий на iPhone.',
  'push.enable': 'Включить',

  'field.displayName': 'Название',
  'field.displayName.hint': 'Видно в выборе учётки на телефоне.',
  'field.domain': 'Сервер',
  'field.domain.hint': 'Из данных провайдера, например sip.example.com.',
  'field.username': 'Логин',
  'field.username.hint': 'Обычно номер или логин у провайдера.',
  'field.password': 'Пароль',
  'field.password.hint': 'Хранится только на iPhone.',
  'field.authUsername': 'Логин авторизации',
  'field.authUsername.hint': 'Только если провайдер дал отдельный.',
  'field.registrar': 'Регистратор',
  'field.registrar.hint': 'Только если провайдер его указал.',
  'field.outboundProxy': 'Прокси',
  'field.outboundProxy.hint': 'Только если провайдер его указал.',
  'field.transport': 'Транспорт',
  'field.transport.hint': 'Как телефон связывается с сервером.',
  'field.port': 'Порт',
  'field.port.hint': 'Пусто — стандартный порт для транспорта.',
  'field.srtp': 'Шифрование звонка',
  'field.srtp.hint': 'Шифруется ли звук разговора.',
  'field.registerIntervalSeconds': 'Перерегистрация',
  'field.registerIntervalSeconds.hint': 'В секундах. Пусто — 600.',
  'field.stunServer': 'STUN-сервер',
  'field.stunServer.hint': 'Помогает за некоторыми роутерами. Пусто — без него.',
  'field.trustedCertificateSha256': 'Доверенный сертификат',
  'field.trustedCertificateSha256.hint': 'Только для TLS: отпечаток SHA-256 сертификата вашей АТС, если телефон не доверяет ему сам (самоподписанный). Пусто — решает система.',
  'field.trustedCertificateSha256.invalid': 'Введите 64 шестнадцатеричные цифры; двоеточия и пробелы можно.',
  'field.codecs': 'Кодеки',
  'field.codecs.hint': 'Телефон предлагает их в этом порядке.',

  'srtp.disabled': 'Выключено',
  'srtp.disabled.note': 'Звук идёт без шифрования. Работает с любым сервером.',
  'srtp.optional': 'Если доступно',
  'srtp.optional.note': 'Шифрует, когда сервер умеет, иначе без шифрования.',
  'srtp.mandatory': 'Обязательно',
  'srtp.mandatory.note': 'Без шифрования звонок не начнётся.',

  'foot.missing': 'Не хватает: {fields}',
  'foot.away': 'Проверка работает, когда iPhone на связи.',
  'foot.password': 'Новый пароль подтверждается на iPhone.',

  'action.check': 'Проверить',
  'action.checking': 'Проверяем…',
  'action.save': 'Сохранить',
  'action.delete': 'Удалить',
  'action.cancel': 'Отменить',
  'action.startOver': 'Начать заново',
  'action.copy': 'Скопировать',
  'action.showLog': 'Показать журнал',

  'check.title': 'Проверка',
  'check.registered': 'Учётка регистрируется.',
  'check.failed': 'Не регистрируется: {reason}',

  'notice.saved': 'Сохранено на iPhone.',
  'notice.savedHere': 'Сохранено здесь. Применится, когда iPhone вернётся.',
  'notice.deleted': 'Учётка удалена.',
  'notice.rejected': 'Отклонено на iPhone.',
  'notice.plansOpen': 'Тарифы открыты на iPhone.',
  'notice.plansClosed': 'iPhone не смог показать тарифы. Откройте на нём Tellvo.app и попробуйте ещё раз.',
  'notice.confirmDelete': 'Подтвердите удаление на iPhone.',
  'notice.confirmPassword': 'Подтвердите новый пароль на iPhone.',
  'notice.deleteLater': 'Удаление применится, когда iPhone вернётся. Подтвердить его нужно на телефоне.',

  'app.section': 'На iPhone',
  'app.appearance': 'Оформление приложения на iPhone',
  'app.appearance.hint': 'Только приложение на телефоне. У этой страницы свой переключатель вверху.',
  'app.appearance.system': 'Как в iOS',
  'app.appearance.light': 'Светлое',
  'app.appearance.dark': 'Тёмное',

  'features.section': 'Функции',
  'features.pushIncoming': 'Звонки при закрытом приложении',
  'features.pushIncoming.hint': 'Звонок дойдёт, даже если Tellvo.app не запущен.',
  'features.pushIncoming.unavailable': 'Появится с подпиской Tellvo.app.',
  'features.sms': 'СМС через провайдера',
  'features.sms.hint': 'Отправка и приём СМС у провайдеров, которые это поддерживают.',
  'features.sms.unavailable': 'В разработке.',
  'features.soon': 'Скоро',
  'features.toggle': 'Включить «{name}»',

  'diag.section': 'Диагностика',
  'diag.log': 'Журнал SIP',
  'diag.log.hint': 'Всё, чем iPhone обменивался с серверами. Пригодится поддержке провайдера.',
  'diag.empty': 'Журнал пуст.',

  'lost.text': 'Проверьте интернет на этом компьютере. Если начать заново, iPhone нужно будет подключить снова, а изменения, которые он ещё не получил, пропадут.',

  'error.rejected': 'Вы отклонили подключение. Начните заново, чтобы подключиться снова.',
  'error.decrypt': 'Не удалось прочитать сообщение телефона. Начните заново, чтобы подключиться снова.',
  'error.bye': 'Телефон завершил сессию.',
  'error.expired': 'Код и QR-код устарели.',
  'error.roomFull': 'К этой странице уже подключён другой браузер.',
  'error.tooMany': 'Слишком много неверных кодов.',
  'error.relay': 'Сервис настройки отклонил подключение ({code}).',
  'field.invalidNumber': 'Введите целое число от {min} до {max}.',
  'landing.text': 'Эта ссылка открывает Tellvo.app на iPhone. Отсканируйте QR-код камерой телефона.',

  // Redesign C (tellvo-voip-client#96)
  'brand.page': 'Настройка телефона',
  'pair.step1': 'Откройте Tellvo.app на iPhone',
  'pair.step2': 'Перейдите в {path}',
  'pair.step2.path': 'Настройки › Управление с компьютера',
  'pair.step3': 'Отсканируйте код камерой',
  'pair.step3.hint': 'Или введите 6 цифр в Tellvo.app. Подойдёт любой способ.',
  'pair.get': 'Ещё нет Tellvo.app?',
  'pair.appStore': 'Загрузите в App Store',
  'console.summary.empty': 'Настроим первую линию',
  'console.summary.all': 'Все линии готовы к звонкам',
  'console.summary.some': 'Готовы линии: {ready} из {total}',
  'console.summary.attention': 'Готовы линии: {ready} из {total}. «{name}» требует внимания.',
  'console.sub.empty': 'Введите здесь данные провайдера. Они появляются на iPhone по мере набора, а iPhone сам их проверит.',
  'console.sub.ok': 'Изменения отсюда появляются на iPhone по мере набора.',
  'console.sub.attention': 'Сервер не принял вход. Откройте линию и исправьте; iPhone попробует снова сразу после сохранения.',
  'console.fix': 'Исправить «{name}»',
  'console.stat.ready': 'Готовы',
  'console.stat.attention': 'Требуют внимания',
  'console.stat.quiet': 'Молчат при закрытом',
  'link.browser': 'Этот браузер',
  'link.encrypted': 'Сквозное шифрование',
  'link.live': 'На связи. Правки видны на iPhone сразу.',
  'link.away': 'iPhone в фоне. Изменения уйдут, когда Tellvo.app снова откроют.',
  'link.waiting': 'Ждут отправки на iPhone: {count}. Уйдут, когда Tellvo.app снова откроют.',
  'link.reconnecting': 'Связь со службой настройки прервалась. Переподключаемся; правки ждут здесь.',
  'link.offline': 'Связь не вернулась. Правки останутся здесь, пока она не появится.',
  'accounts.lead': 'Каждая линия — это SIP-учётка. Выключите линию, чтобы она не звонила, не удаляя её.',
  'accounts.addHint': 'Сервер, логин и пароль от провайдера',
  'accounts.fix': 'Исправить вход',
  'accounts.edit': 'Изменить «{name}»',
  'accounts.drag': 'Перетащите, чтобы изменить порядок набора',
  'accounts.moveHint': 'Учётки набирают в этом порядке. Перетащите карточку, чтобы переставить её; с клавиатуры карточку в фокусе переставляют Alt и стрелки.',
  'accounts.moved': 'Перемещено на позицию {n} из {total}',
  'fact.off': 'Выключена, звонков нет',
  'fact.open': 'Звонит при открытом приложении',
  'fact.closed': 'Звонит даже при закрытом приложении',
  'fact.enc.off': 'Звонки без шифрования',
  'fact.enc.optional': 'Звонки шифруются',
  'fact.enc.mandatory': 'Только шифрованные звонки',
  'line.ext': 'Доб. {n}',
  'start.1.title': 'Добавьте линию',
  'start.1.text': 'Сервер, логин и пароль. Провайдер присылает их при подключении.',
  'start.2.title': 'Проверьте',
  'start.2.text': 'iPhone войдёт на сервер и покажет результат здесь.',
  'start.3.title': 'Принимайте звонки',
  'start.3.text': 'Звонки приходят на iPhone как обычные, даже на заблокированный экран.',
  'plan.trial': 'Первый месяц бесплатно',
  'plan.title': 'Пусть дозваниваются, даже когда Tellvo.app закрыт',
  'plan.lead': '{lines} звонят, только пока приложение открыто. С подпиской iPhone звонит на экране блокировки, как обычный телефон, а приложение остаётся закрытым, пока вы не ответите.',
  'plan.lead.yourLines': 'Ваши линии',
  'plan.billing': 'Период оплаты',
  'plan.monthly': 'Помесячно',
  'plan.yearly': 'На год',
  'plan.save.months': '2 месяца бесплатно',
  'plan.save.percent': 'Выгода {n}%',
  'plan.source': 'Цены с {device} · App Store, {region}',
  'plan.pick': 'Тариф',
  'plan.personal': 'Личный',
  'plan.personal.limits': '3 учётки, 2 устройства',
  'plan.family': 'Семейный',
  'plan.family.limits': 'До 6 человек, каждому 3 учётки и 2 устройства',
  'plan.pro': 'Про',
  'plan.pro.limits': '10 учёток, 5 устройств',
  'plan.fits': 'Хватит на ваши учётки',
  'plan.perMonth': '/ месяц',
  'plan.perYear': '/ год',
  'plan.try': 'Попробовать «{plan}» месяц бесплатно',
  'plan.subscribe': 'Оформить «{plan}»',
  'plan.ctaHint': 'Откроет тарифы на {device}. Подтверждаете через Face ID; отменить можно в любой момент в App Store.',
  'plan.away': 'Откройте Tellvo.app на iPhone, чтобы увидеть цены и начать бесплатный месяц.',
  'plan.how': 'Подписка оформляется в Tellvo.app на iPhone:',
  'plan.currency': 'Цены в валюте вашего App Store.',
  'plan.path': 'Настройки › Звонки при закрытом приложении',
  'plan.shot.alt': 'Входящий звонок на экране блокировки, пока Tellvo.app закрыт',
  'plan.shot.caption': 'Приложение закрыто. Звонок всё равно приходит.',
  'plan.shot.line': 'Основная · Tellvo.app',
  'plan.shot.incoming': 'входящий вызов',
  'editor.group.signin': 'Вход',
  'editor.group.security': 'Шифрование и звук',
  'editor.group.connection': 'Соединение подробнее',
  'editor.group.connection.hint': 'Обычно не нужно',
  'editor.close': 'Закрыть',
  'editor.new.sub': 'Настройки появляются на iPhone по мере набора',
  'check.showLog': 'Показать SIP-сообщения',
  'features.paid': 'По подписке',
};
